import { Controller } from '@hotwired/stimulus';

import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, Thumbs } from 'swiper/modules';

export default class SwiperController extends Controller {
    static values = {
        options: {type: Object, default: {}}
    };

    static targets = [
        'swiper',
        'thumbs',
        'prevButton',
        'nextButton',
    ];

    get swiperEl() {
        return this.hasSwiperTarget ? this.swiperTarget : this.element;
    }

    get prevButton() {
        return this.hasPrevButtonTarget ? this.prevButtonTarget : null;
    }

    get nextButton() {
        return this.hasNextButtonTarget ? this.nextButtonTarget : null;
    }

    get thumbs() {
        return this.hasThumbsTarget ? this.thumbsTarget : null;
    }


    swiper;

    connect() {
        this.swiper = new Swiper(this.swiperEl, {
            ...this.options,
        });
    }

    disconnect() {
        this.swiper?.destroy();
        this.swiper = null;
    }

    get options() {
        const prevButton = this.prevButton || '.swiper-button-prev';
        const nextButton = this.nextButton || '.swiper-button-next';

        const passedOptions = this.optionsValue;

        const options = {
            modules: [Autoplay, Navigation, Pagination, Thumbs],

            loop: true,

            lazyPreloaderClass: 'swiper-loading',

            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },

            pagination: {
                el:                 '.swiper-pagination',
                dynamicBullets:     true,
                dynamicMainBullets: 3,
            },

            ...passedOptions,
        };

        const thumbsOptions = {
            spaceBetween:        10,
            slidesPerView:       4,
            freeMode:            true,

            ...options.thumbs,
        };

        delete options.thumbs;

        const thumbsTarget = this.thumbs;
        if (thumbsTarget) {
            const thumbs = new Swiper(thumbsTarget, thumbsOptions);
            options.thumbs = {
                swiper: thumbs,
            };

            if (passedOptions.loop !== true) {
                // require explicit "loop: true" to prevent bug https://github.com/nolimits4web/swiper/issues/7669
                options.loop = false;
            }
        }

        return options;
    }
}
